import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { useNavigate } from "react-router-dom";
import DefaultGrid from "../../Components/Default/DefaultGrid";
import { FrontEndRoutes } from "../../config/front-end-routes";
import ModalDelete from "../../Components/Modal/ModalDelete";
import {useFilters} from "../../Components/Filters/UseFilter";
import { toast } from "react-toastify";

interface Usuario {
  id_usuario: string;
  nome: string;
  email: string;
  tabela_preco: string;
  clientes_count: number;
  pedidos_count: number;
}

const PageUsuarios: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [deleting, setDeleting] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<Usuario | null>(null);
  const [users, setUsers] = useState<Usuario[]>([]);
  const { filters, handleFilterChange } = useFilters([]);

  const columns = [
    { key: "id_usuario", label: "Código", filterType: "text" },
    { key: "nome", label: "LOGIN", filterType: "text" },
    { key: "email", label: "EMAIL", filterType: "text" },
    { key: "tabela_preco", label: "TABELA DE PREÇO", filterType: "text" },
    { key: "clientes_count", label: "Nº DE CLIENTES", filterType: "text" },
    { key: "pedidos_count", label: "Nº DE PEDIDOS", filterType: "text" },
  ];

  const handleUsers = () => {
    setLoading(true);
    api.get(BackEndRoutes.routes.USUARIOS.LIST)
        .then((response) => {
          if (response.data) {
            setUsers(response.data);
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar usuários:", error);
          toast.error("Não foi possível carregar a lista de usuários.");
        })
        .finally(() => {
          setLoading(false);
        });
  };

  const handleDelete = () => {
    if (!selectedItem) return;

    setDeleting(true);
    api.delete(
        BackEndRoutes.routes.USUARIOS.DELETE.replace(":id", selectedItem.id_usuario)
    )
        .then(() => {
          setShowModal(false);
          setSelectedItem(null);
          handleUsers(); // Recarrega a lista após a exclusão
        })
        .catch((error) => {
          console.error("Erro ao deletar usuário:", error);
          alert("Não foi possível deletar o usuário.");
        })
        .finally(() => {
          setDeleting(false);
        });
  };

  useEffect(() => {
    handleUsers();
  }, []);

  return (
    <div className="d-flex flex-column container-fluid">
      <DefaultGrid
        title="Lista de Usuários"
        onAdd={() => navigate(FrontEndRoutes.USUARIOS.CREATE)}
        columns={columns}
        filters={filters}
        handleFilterChange={handleFilterChange}
        items={users}
        itemsPerPage={10}
        loading={loading}
        onReload={handleUsers}
        onEdit={(item: Usuario) => {
          if (item?.nome) {
            navigate(
              FrontEndRoutes.USUARIOS.EDIT.replace(":id", item.id_usuario)
            );
          }
        }}
        onDelete={(item: Usuario) => {
          setShowModal(true);
          setSelectedItem(item);
        }}
      />

        {users.length === 0 && !loading && <p>Nenhum usuário encontrado.</p>}

        <ModalDelete
            show={showModal}
            title="Confirmar Exclusão"
            message={`Deseja confirmar a exclusão do usuário: ${selectedItem?.nome}?`}
            loading={deleting}
            onConfirm={handleDelete}
            onCancel={() => {
              setShowModal(false);
              setSelectedItem(null);
            }}
        />
      </div>
  );
};

export default PageUsuarios;
